import React from 'react'
import './PolicyListCard.scss'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import { isMobile } from 'react-device-detect'
import { Grid } from '@material-ui/core';
import FlexView from 'react-flexview/lib';
import { ReactComponent as CalenderIcon } from '../../assets/calendar.svg';
import dayjs from 'dayjs';


export const PolicySelectCard = ({insurance, small, onPolicySelect }) => {
    const dateFormat = isMobile || small 
        ? FirebaseService.getValue(FirebaseConfigKey.SHORT_DATE_FORMAT).toUpperCase() 
        : FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)

    return (
        <div className="policy-card">


            {/* Policy Title Section */}
            <FlexView column hAlignContent="center" className="margin-bottom-large">

                    <h1 className="text-title bold">Your {insurance.insurancePeriodDescription} Policy</h1>
          
                <FlexView vAlignContent="center" className="margin-top-small">
                    <FlexView marginRight={5} className="text-body">{insurance.policyNumber}</FlexView>
                </FlexView>
            </FlexView>

            <Grid container spacing={2} className="margin-bottom-large">

            <Grid item xs={12}>
                <FlexView column hAlignContent="center">
                <FlexView marginBottom={12}>

                        <CalenderIcon className="x-medium-icon" />
                        </FlexView>

                    <FlexView className={`${small ? 'text-tiny' : 'text-small'} bold margin-top-small`}>Coverage Period</FlexView>
                    <span className="text-tiny margin-top-small">{dayjs(insurance.insuranceStart).format(dateFormat)} - {dayjs(insurance.insuranceEnd).format(dateFormat)}</span>
                </FlexView>
            </Grid>
        </Grid>
        <Grid container spacing={2} className="margin-bottom-basic">
                <Grid item xs={12}>
                    <button className="button-primary full-width" onClick={() => onPolicySelect(insurance)}>
                        <FlexView vAlignContent="center" hAlignContent="center">
                            <FlexView className={`${isMobile && 'text-medium'} bold`} marginLeft={4}>
                            Select Policy   
                            </FlexView>
                        </FlexView>
                    </button>
                </Grid>

            </Grid>
        </div>

    )
}